import React from 'react';

import FormRemuneracaoGreenerBuyer from './FormRemuneracaoGreener';

const RemuneracaoGreenerBuyer = ({
    cancelar,
    idEmpresa
}) => {
    const handleCancelar = () => {
        cancelar(1);
    }

    return (
        <div className='row ml-1 mt20'>
            <FormRemuneracaoGreenerBuyer handleCancelar={handleCancelar} idEmpresa={idEmpresa} />
        </div>
    )
}

export default RemuneracaoGreenerBuyer;